import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/bet777/images/footer/logoFooter.png';

export default function Index() {
  return <Image src={logo} maxW="100px" />;
}
